import React, { useState } from "react";
import ReleaseNoteCard from "./ReleaseNoteCard";
import { releaseNotesData } from "../../../../Utils/releaseNotesData";
import ReleaseNoteFilterMenu from "./ReleaseNoteFilterMenu";
import { Divider, Empty } from "antd";
import { ReleaseNoteType } from "../../../../Interface";
import "./ReleaseNotes.scss";

const ReleaseNotes: React.FC = () => {
  const [filteredReleaseNotes, setFilteredReleaseNotes] =
    useState<ReleaseNoteType[]>(releaseNotesData);
  return (
    <section className="release-notes">
      <ReleaseNoteFilterMenu
        setFilteredReleaseNotes={setFilteredReleaseNotes}
      />
      <Divider style={{ margin: "0" }} />
      {filteredReleaseNotes.length > 0 ? (
        <div className="release-notes-container">
          {filteredReleaseNotes.map((releaseNote) => (
            <ReleaseNoteCard
              key={releaseNote.version}
              releaseNote={releaseNote}
            />
          ))}
        </div>
      ) : (
        <div>
          <Empty
            description="No release notes found with applied filters"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </div>
      )}
    </section>
  );
};

export default ReleaseNotes;
